/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatBottomSheet, MatDialog } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IceexpansionpanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,  ChartTypes,
  SECTION_CONTROL_ALIGNMENT
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { ReportService } from 'projects/icemedx-lib/src/services/report/report.service';
import { ScheduleService } from 'projects/icemedx-lib/src/services/schedule/schedule.service';
import { MedicalcodesService } from 'projects/icemedx-lib/src/services/medicalcodes/medicalcodes.service';

import { report, ReportBarCodeType, reportDataField, ReportDataTypes, reportField, reportObject, ReportObjectType, reportSection, ReportSectionTypes, reportSummationField, reportSystemData, reportSystemField, ReportSystemFieldTypes, reportTextField, Report_Alignment, Report_Border_Style, Report_Layout_Type, Report_Mode_Type, Report_Page_Sizes } from '../../../../icemedx-lib/src/models/reports/report';
import { ViewreportComponent } from '../viewreport/viewreport.component';
import { reportdata } from 'projects/icemedx-lib/src/models/reports/reportdata';
import { SignerService } from '../../../../icemedx-lib/src/login/signer.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { IceMultimediaService } from '../../../../icemedx-lib/src/services/multimedia/icemultimedia.service';
import { CustomFormService } from '../../../../icemedx-lib/src/services/custom/customform.service';

@Component({
  selector: 'app-printreport',
  templateUrl: './viewreport.component.html',
  styleUrls: ['./viewreport.component.scss'],
  providers: [IceNavService, AppService]
})
export class PrintreportComponent extends ViewreportComponent implements OnInit {
  // data members

  // member settings

  // sample member settings

  constructor(appSvc: AppService,
    navSvc: IceNavService,
    loginSvc: LoginService,
    router: Router,
    activatedRoute: ActivatedRoute,
    rptService: ReportService,
    frmService: CustomFormService,
    schService: ScheduleService,
    signerSvc: SignerService,
    codeSvc: MedicalcodesService,
    domainSvc: DomainService,
    changeDetectorRefs: ChangeDetectorRef,
    dialog: MatDialog,
    bottomSheet: MatBottomSheet) {

    super(appSvc, navSvc, loginSvc, router, activatedRoute,
      rptService, frmService, schService, signerSvc, codeSvc, domainSvc,
      changeDetectorRefs, dialog, bottomSheet);

    appSvc.setHideBreadCrum(true);
    this.setReportMode(Report_Mode_Type.modePrint);
  }

  ngOnInit() {
  }

  viewSetup(rep: report): IcepanelcontainerSettings {
    if (rep.RPTSECTIONS.length > 0)
      this.setReportLayoutType(Report_Layout_Type.rltSectionLayout);

    let setup: IcepanelcontainerSettings = null;
    try {
      if (rep == null) {
        return null;
      }

      setup = super.viewSetup(rep);
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  onLoadReportData(rep: report, repData: reportdata, sections: IcepanelsectionSettings[]): void {
    if (this.getReportLayoutType() == Report_Layout_Type.rltSectionLayout) {
      const reportCanvas: HTMLCanvasElement = document.getElementById("reportCanvas") as HTMLCanvasElement;
      this.onPrint(rep, repData, reportCanvas);
    }
  }

  onPrint(rep: report, repData: reportdata, reportCanvas: HTMLCanvasElement): void {
    /*
    // To do we need the src_type to determine what to fill outputRecords with
    rep.initializeReport(); // To do we need to know the primary key
    if (repData.PATIENTSTATS.length == 0) return;

    let ptStat = repData.PATIENTSTATS[0];
    if (ptStat == null) return;

    for (let imedActy = 0; imedActy < ptStat.MEDACTIVITIES.length; imedActy++) {
      let rec = repData.getDataMedActivity(ptStat, ptStat.MEDACTIVITIES[imedActy], rep.outputColumns);
      if (rec != null)
        rep.outputRecords.push(rec);
    }
    this.getReportService().onDraw(rep, reportCanvas);
    */
  }
}
